import CloseRfq from '../../../../../../client/src/rfq/src/viewmodel/CloseRfqViewModel';
import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesCloseRfq extends DesBaseRfq {

    constructor() {
        console.log('CloseRfq invoked');
        super(CloseRfq);
    }
}
if (!window.customElements.get('des-close-rfq')) {
    window.customElements.define('des-close-rfq', DesCloseRfq);
}
